import {
  EDIT_OTP_ROTATION,
  GET_OTP_ROTATION_DETAIL,
  requestType,
  failedType,
  succeedType,
} from "./../actions/actionTypes";

const initState = {
  otp_rotations: [],
  otp_rotation: {},
  is_fetching: false,
  getting_otp_rotation_detail: false,
  editting_otp_rotation: false,
};

export const otpRotationReducer = (state = initState, action) => {
  switch (action.type) {
    
    case requestType(GET_OTP_ROTATION_DETAIL):
      return {
        ...state,
        getting_otp_rotation_detail: true,
      };
    case succeedType(GET_OTP_ROTATION_DETAIL):
      return {
        ...state,
        getting_otp_rotation_detail: false,
        otp_rotation: action.otp_rotation,
      };
    case failedType(GET_OTP_ROTATION_DETAIL):
      return {
        ...state,
        getting_otp_rotation_detail: false,
      };
    case requestType(EDIT_OTP_ROTATION):
      return {
        ...state,
        editting_otp_rotation: true,
      };
    case succeedType(EDIT_OTP_ROTATION):
      return {
        ...state,
        editting_otp_rotation: false,
      };
    case failedType(EDIT_OTP_ROTATION):
      return {
        ...state,
        editting_otp_rotation: false,
      };
    default:
      return state;
  }
};
